import { View, Text, Image, TouchableOpacity } from "react-native";
import React from "react";
import { LinearGradient } from "expo-linear-gradient";
import UserIcon from "../../assets/svg/UserIcon";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import { white } from "../../colors";
import ProgressBar from "../custom/ProgressBar";
import { happyPencil, lightBulb, question } from "../../imports";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";

export default function ASQSE2Test(props) {
  const navigation = useNavigation();
  const main = useSelector((store) => store.main);
  return (
    <TouchableOpacity
      activeOpacity={1}
      onPress={() => navigation.navigate("TestNavigator")}
      style={{
        width: "92%",
        marginVertical: 15,
        borderRadius: 10,
        paddingVertical: 10,
        paddingHorizontal: 15,
        flexDirection: "row",
        backgroundColor: "#59d1ff",
      }}
    >
      <View style={{ flex: 12, flexDirection: "column" }}>
        <View>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <UserIcon />
            <MyText style={{ marginHorizontal: 5, color: white, fontSize: 18 }}>
              {`${props.participant}`}
            </MyText>
            <MyText style={{ color: white }}>
              {translate("number of participant")}
            </MyText>
          </View>
          <View
            style={{
              marginVertical: main.rtl ? 3 : 20,
              flexDirection: "row",
              alignItems: "center",
              marginTop: main.rtl ? -5 : 15,
            }}
          >
            <MyText
              style={{
                color: white,
                fontSize: 30,

                marginLeft: 10,
              }}
            >
              {translate("ASQSE2 test")}
            </MyText>
           
          </View>
          <View style={{ marginTop: -12 }}>
            {main.rtl && (
              <MyText
                style={{
                  color: "#009cd8",
                  fontSize: 20,

                  marginLeft: 10,
                }}
              >
                آزمون اجتماعی عاطفی کودکان
              </MyText>
            )}
          </View>
          <View style={{ marginTop: 1 }}>
            <ProgressBar progress={props.percent} color="#59d1ff" />
          </View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 3,
            }}
          >
            <MyText
              style={{
                writingDirection: "ltr",
                marginHorizontal: 3,
                color: "white",
              }}
            >
              {`${props.percent}%`}
            </MyText>

            <MyText style={{ color: "white", fontSize: 13 }}>
              {translate("test you have done")}
            </MyText>
          </View>
        </View>
      </View>
      <View style={{ flex: 4, overflow: "visible", zIndex: 999 }}>
        <Image
          resizeMode="contain"
          source={lightBulb}
          style={{
            zIndex: 999,
            width: 139,
            marginTop: -30,
            height: 150,
            marginLeft: -30,
          }}
        />
      </View>
    </TouchableOpacity>
  );
}
